export const NOTI_NOT_VIEWED_YET = 0;
export const NOTI_NOT_READ_YET = 1;
export const NOTI_READ = 2;
export const NOTI_DISABLE = -1;
